import React from 'react'
import PropTypes from 'prop-types'
import { TEL_NUMBER } from 'config/constants'
import { scrollIntoView } from 'utils/helpers'
import { Text, H3 } from 'components/atoms/Typography'
import Link from 'components/atoms/Link'
import DefaultDialog from 'components/organisms/Dialog'

const ModalTextFailure = () => (
  <Text.Block textAlign="center">
    <Text fontSize={{ desktop: 'l' }} textAlign="center">
      NuNu can only help if you pay more than $ 2000 monthly for rent. Did you
      maybe mistype? Try again! If you'd like, you can call us directly at:
    </Text>
    <Text>
      <Link href={`tel:${TEL_NUMBER}`} fontSize={['m', 'm', 'l']}>
        {TEL_NUMBER}
      </Link>
    </Text>
  </Text.Block>
)

const ModalTextSuccess = () => (
  <Text fontSize={{ desktop: 'l' }} textAlign="center">
    If you'd like to hear more about an Opportunity to buy your house with ZERO
    downpayment, leave us your contact information and we will be with you
    shortly!
  </Text>
)

const ModalHeadingFailure = () => <H3 textAlign="center">Thank You!</H3>

const ModalHeadingSuccess = () => (
  <H3 textAlign="center">
    Congratulations! <br />
    You pre-qualify for buying a house
  </H3>
)

const Dialog = ({ onCloseModalButtonClick, isModalOpen, isSuccess }) => (
  <DefaultDialog.Narrow
    onClose={onCloseModalButtonClick}
    onClick={
      isSuccess
        ? () => {
            onCloseModalButtonClick()
            scrollIntoView('contact-form')
          }
        : onCloseModalButtonClick
    }
    isVisible={isModalOpen}
    buttonLabel={isSuccess ? 'CONTINUE' : 'RECALCULATE'}
    title={isSuccess ? <ModalHeadingSuccess /> : <ModalHeadingFailure />}
    body={isSuccess ? <ModalTextSuccess /> : <ModalTextFailure />}
  />
)

Dialog.propTypes = {
  isModalOpen: PropTypes.bool.isRequired,
  isSuccess: PropTypes.bool.isRequired,
  onCloseModalButtonClick: PropTypes.func.isRequired,
}

export default Dialog
